'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnSizer = undefined;

var _ColumnSizer = require('./ColumnSizer');

var _ColumnSizer2 = _interopRequireDefault(_ColumnSizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ColumnSizer2.default;
exports.ColumnSizer = _ColumnSizer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/commonjs/ColumnSizer/index.js
// module id = 1402
// module chunks = 0